const isoDateOnlyRe = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Конвертация в локальный Date. Обрабатывает строки YYYY-MM-DD как local midnight
 * (new Date('2024-12-25') интерпретирует как UTC, что сдвигает дату западнее UTC).
 */
export const toLocalDate = (value: Date | string | number): Date => {
    if (value instanceof Date) return value;
    if (typeof value === 'string' && isoDateOnlyRe.test(value)) {
        const [y, m, d] = value.split('-').map(Number);
        return new Date(y, m - 1, d);
    }
    return new Date(value);
};
